import { useGame } from "../../data/gameContext";
import bugBustInstance from "../../debugger/bugBustLog";

interface IStartGameProps {
    startGame: () => void;
    loadGame: () => void;
}

export default function StartGame(props: IStartGameProps) {
    const { updateGameState } = useGame();

    function handleLoadSavedGame() {
        const savedGame = localStorage.getItem("savedGame");
        if (savedGame) {
            bugBustInstance.add("Loading saved game");
            let newGameState = JSON.parse(savedGame);
            console.log(newGameState);
            updateGameState(newGameState);
        }
        props.startGame();
    }

    return (
        <div>
            <p>Will put something here in time about the game, possibly a load saved game option too</p>
            <p>Mainly this is here because I need a user action to make the window full screen</p>
            <p>Also, this game requires a 1920x1080 resolution</p>
            <p>Click the button below to start the game</p>
            <button onClick={() => props.startGame()}>Start Game</button>
            <p>Added the ability to save the game (come out of full screen mode and save and quit)</p>
            <p>You will need to delete the save game from local storage if the game object structure changes.</p>
            <button onClick={handleLoadSavedGame} >Load Saved Game</button>
        </div>
    );
}